<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<!--会员添加修改-->
			<Form label-position="right" v-if="modal.type=='add'||modal.type=='up'" ref="memberForm" :model="memberInfo"
				:label-width="90">
				<Row :gutter="24" type="flex" align="bottom">
					<Col span=12>
					<FormItem label="上传头像:" prop="Member">
						<div style="float: right;width: 100%;">
							<Upload :action="getMemberInfoUrl" :headers="upHeader" :on-error="uploadError"
								:on-success="uploadSuccess">
								<Button icon="ios-cloud-upload-outline">点击上传头像</Button>
							</Upload>
						</div>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem prop="Member">
						<div style="float: right;width: 100%;text-align: center;" class="memberStyle">
							<Avatar size="large" :src="memberInfo.Headimgurl" />
						</div>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=24>
					<FormItem label="会员头像" prop="Headimgurl">
						<Input :disabled="modal.canInput" v-model="memberInfo.Headimgurl" placeholder="会员头像"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="会员名称:" prop="MemberName">
						<Input :disabled="modal.canInput" v-model="memberInfo.MemberName" placeholder="输入会员名称"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="手机号码" prop="PhoneNo">
						<Input :disabled="modal.canInput" v-model="memberInfo.PhoneNo" placeholder="输入手机号码"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="性别" prop="Sex">
						<i-switch true-value='男' false-value='女' v-model="memberInfo.Sex" size="large">
							<span slot="open">男</span>
							<span slot="close">女</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="是否接受推送" prop="IsPushed">
						<i-switch :true-value='1' :false-value='0' v-model="memberInfo.IsPushed" size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="身份证号" prop="IdentityNo">
						<Input :disabled="modal.canInput" v-model="memberInfo.IdentityNo" placeholder="身份证号"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="会员昵称" prop="Nickname">
						<Input :disabled="modal.canInput" v-model="memberInfo.Nickname" placeholder="会员昵称"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="出生日期" prop="Borndate">
						<Input :disabled="modal.canInput" v-model="memberInfo.Borndate" placeholder="出生日期"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="备注" prop="Remark">
						<Input :disabled="modal.canInput" v-model="memberInfo.Remark" placeholder="备注"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">取消</Button>
				<Button type="success" size="large" @click="modalOk('add')">添加</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">取消</Button>
				<Button type="success" @click="modalOk('up')" size="large">修改</Button>
			</div>
		</Modal>
		<Modal :z-index="zindex" v-model="showMap" :title="modal.Title" width="40%">
			<div id="map" style="width: 100%;height: 300px;"></div>
			<div slot="footer">
				<Button type="success" size="small" @click="closeMap">关闭</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import webapi from '../../../../webapi';
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('输入运营商Id'));
				} else {
					if (this.StationForm.OperatorId.length !== 9) {
						callback(new Error('输入社会信用代码码第9~倒数第2位'));
					}
					callback();
				}
			};
			return {
				getMemberInfoUrl: webapi.base_api_url + '/Member/GetMemberInfo',
				modal: {
					Title: "会员添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				memberInfo: {
					MemberName: "650",
					PhoneNo: "650",
					Sex: "男",
					Headimgurl: "https://i.loli.net/2017/08/21/599a521472424.jpg",
					Borndate: "650",
					IdentityNo: "650",
					Nickname: "650",
					IsPushed: 1,
					Remark: "650"
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				/******分割线********/
				//地图modal
				center: [114.198595, 22.633595],
				showMap: false,
				//字段显示
				ifAddStation: true,
				//场站信息是否只能查看
				ifViewStation: false,
				//校验字段
				ruleInline: {
					OperatorId: [{
						validator: validateOpId,
						trigger: 'blur',
					}],
					Type: [{
						required: true,
						message: '运营商类型',
						trigger: 'change',
						type: 'number'
					}],
					OperatorName: [{
						required: true,
						message: '运营商名称',
						trigger: 'blur'
					}],
					OperatorTel1: [{
						required: true,
						message: '运营商电话1',

					}],
					OperatorName: [{
						required: true,
						message: '供应商名称',
						trigger: 'change',
					}],
				},
			};
		},
		methods: {
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = "会员添加";
					_this.modal.type = "add";
					delete _this.memberInfo.MemberId;
					_this.$refs.memberForm.resetFields()
				} else if (type == "up") {
					_this.modal.Title = "会员修改";
					_this.modal.type = "up";
					let upMember = _this.data1.filter((item) => {
						return item.MemberId == memberId
					})
					_this.memberInfo = {
						MemberId: upMember[0].MemberId,
						MemberName: upMember[0].MemberName,
						PhoneNo: upMember[0].PhoneNo,
						Sex: upMember[0].Sex == "" ? "女" : upMember[0].Sex,
						Headimgurl: upMember[0].Headimgurl == "https://i.loli.net/2017/08/21/599a521472424.jpg" ?
							"" : upMember[0].Headimgurl,
						Borndate: upMember[0].Borndate,
						IdentityNo: upMember[0].IdentityNo,
						Nickname: upMember[0].Nickname,
						IsPushed: upMember[0].IsPushed,
						Remark: upMember[0].Remark
					};
				}
				_this.modal.ifShow = true
			},
			//查看详细信息
			getUpdateMessage: function(item) {
				console.log("修改查看运营商方法OperatorObj" + item);
				console.log(item)
				const _this = this;
				_this.StationForm = item
				// this.$nextTick(() => {
				// })
				_this.StationPicturesArray = [];
				let PictureStr = item.LogoImg;
				let picList = []
				if (PictureStr != "") {
					_this.StationPicturesArray = PictureStr.split(",")
					for (let i = 0; i < _this.StationPicturesArray.length; i++) {
						let picture = {
							name: _this.StationPicturesArray[i],
							url: webapi.base_api_url + _this.StationPicturesArray[i]
						}
						picList.push(picture)
					}
				}
				_this.defaultList = picList
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					_this.uploadList = _this.$refs.upload.fileList
				})
			},
			//modal取消操作
			cancelPictures: function() {
				const _this = this
				_this.PictureUpCache = []
				if (_this.PictureDelCache.length > 0) {
					console.log("取消添加或更新modal，删除添加的缓存图片")
					let picsArr = _this.PictureDelCache
					let StationPictures = ''
					for (let i = 0; i < picsArr.length; i++) {
						if (i == (picsArr.length - 1)) {
							StationPictures += picsArr[i]
						} else {
							StationPictures += picsArr[i] + ','
						}
					}
					_this.deletePicture(StationPictures)
				}
			},
			clearModal: function() {
				this.$refs.memberForm.resetFields();
			},
			//上传文件
			uploadSuccess: function(response, file, fileList) {
				console.log("上传文件成功")
				console.log(response)
				console.log(file)
				console.log(fileList)
			},
			//上传文件error
			uploadError: function(response, file, fileList) {
				console.log("上传文件错误")
				console.log(response)
				console.log(file)
				console.log(fileList)
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addMember();
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.upMember();
						break;
					default:
						break;
				}
			},
			//添加会员
			addMember: function() {
				const _this = this;
				let parms = _this.memberInfo
				_this.$axios.post(webapi.base_api_url + "/Member/AddMember", parms, {}).then(res => {
					console.log("新增会员")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('添加成功');
						_this.handleSubmit();
						_this.modalOk("cancle")
					} else {
						this.$Message.success(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//修改会员
			upMember: function() {
				const _this = this;
				let parms = _this.memberInfo
				_this.$axios.post(webapi.base_api_url + "/Member/ModifyMember", parms, {}).then(res => {
					console.log("修改会员")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('修改成功');
						_this.handleSubmit();
						_this.modalOk("cancle")
					} else {
						this.$Message.success(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//会员注销
			DeleteMember: function(MemberId) {
				const _this = this;
				let parms = {
					MemberId: MemberId
				};
				_this.$axios.post(webapi.base_api_url + "/Member/DeleteMember", parms, {}).then(res => {
					console.log("注销会员")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('注销成功');
						_this.handleSubmit();
					} else {
						this.$Message.success('注销失败');
						this.$Message.success(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//地图modal
			// mapOpen: function() {
			// 	this.showMap = true;
			// 	gaodeMap.initMap("map", 10, this.center, 'normal');
			// 	gaodeMap.mapOn2(this);
			// },
			// closeMap: function() {
			// 	gaodeMap.map.destroy();
			// 	gaodeMap.map = '';
			// 	this.showMap = false;
			// },
			deletePicture: function(pictureStr) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Common/DeleteImage", {
					FilePath: pictureStr
				}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.info('删除成功');
						_this.PictureDelCache = []
						_this.$emit('handleSubmit')
					} else {
						_this.$Message.info('图片删除失败');
						_this.$emit('handleSubmit')
					}
				})
			},
			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')
				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '格式错误',
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '图片太大',
					desc: '文件' + file.name + ' 图片太大请选择小于 2M.'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
			PayMethod1: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					console.log(pay)
					console.log(pay.substring(5, 6))
					return Number(pay.substring(5, 6))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 1;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 1;
					}
				}
			},
			PayMethod2: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(4, 5))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 2;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 2;
					}
				}
			},
			PayMethod3: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(1, 2))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 16;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 16;
					}
				}
			},
			PayMethod4: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}

					return Number(pay.substring(0, 1))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 32;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 32;
					}
				}
			}
		}
	}
</script>

<style>
</style>
